'use client';

import { useEffect } from 'react';

import { Radio, RadioList } from '@bytel/trilogy-react-ts';

import { Connectivity, PlanType } from '@app-types/product';

import getRadioLabels from '@helpers/network-radio';

import { useHome } from '@landing/hooks';

interface NetworkButtonsProps {
    baseProduct: PlanType | null;
}

export function NetworkButtons({ baseProduct }: Readonly<NetworkButtonsProps>) {
    const { setSelectedOption, setSelectedNetwork, selectedNetwork } = useHome();

    const isOffer5g = selectedNetwork === Connectivity.FIVE_G || baseProduct?.maxConnections === Connectivity.FIVE_G;
    const isOffer4g = !isOffer5g;

    useEffect(() => {
        setSelectedOption(null);
    }, []);

    if (!baseProduct) {
        return null;
    }

    const onClick = (network: Connectivity) => {
        if (!baseProduct) return;

        setSelectedNetwork(network);
        if (network === Connectivity.FIVE_G && baseProduct.option5g && Object.values(baseProduct.option5g).length > 0) {
            setSelectedOption(baseProduct.option5g);
        } else {
            setSelectedOption(null);
        }
    };

    const { fourGRadio, fiveGRadio } = getRadioLabels(baseProduct, selectedNetwork);

    return (
        <RadioList className='byou-radios network'>
            <Radio
                onClick={() => onClick(Connectivity.FOUR_G)}
                description={fourGRadio.description}
                disabled={!fourGRadio.valid}
                label='4G'
                horizontalTile
                tile
                name='checkboxNetwork'
                value='1'
                checked={isOffer4g}
                className={fourGRadio.invisibleDescription ? 'has-invisible-description' : ''}
                id='4G'
            />
            <Radio
                onClick={() => onClick(Connectivity.FIVE_G)}
                description={fiveGRadio.description}
                disabled={!fiveGRadio.valid}
                checked={isOffer5g}
                label='5G'
                horizontalTile
                tile
                className={fiveGRadio.invisibleDescription ? 'has-invisible-description' : ''}
                id='5G'
            />
        </RadioList>
    );
}
